<template>
  <v-autocomplete
    :append-icon="null"
    v-bind="$attrs"
    v-on="$listeners"
    outlined
    no-filter
    hide-no-data
    :items="items"
    :search-input.sync="search"
    :loading="isLoading"
    :value="value"
    :item-text="field"
    :item-value="field"
    :title="value"
    ref="select"
		@blur="$emit('blur')"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <template v-for="(_, slot) of $slots" v-slot:[slot]>
      <slot :name="slot" />
    </template>
    <template #item="data">
      <slot name="item" v-bind="data" />
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'debounce';
import Inputmask from 'inputmask';

export default {
  props: ['value' ,'field', 'suggestions', 'mask', 'loader'],
  name: 'SuggestField',
  data: function () {
    return {
      search: '',
      loadedSuggestions: this.suggestions,
      isLoading: false,
      pasteHandler: this.onPaste.bind(this),
    }
  },
  computed: {
    items: function() {
      if(!this.value)return this.loadedSuggestions;
      const found = this.loadedSuggestions.find(item => item && item[this.field] === this.value);
      return found ? this.loadedSuggestions : [...this.loadedSuggestions, this.value];
    },
    inputRef() {
      return this.$refs.select.$refs.input;
    },
  },
  mounted() {
    if (this.mask) this.initMask();
    if(this.inputRef) {
      this.inputRef.addEventListener("paste", this.pasteHandler)
    }
  },
  beforeDestroy() {
    if(this.inputRef) {
      this.inputRef.removeEventListener("paste", this.pasteHandler)
    }
  },
  methods: {
    initMask() {
      const fixed = this.mask.replaceAll('#', '9');
      const im = new Inputmask(fixed, {
        showMaskOnHover: false,
        placeholder: "",
        onincomplete: () => {
          this.$emit('input', '');
        },
      });

      im.mask(this.inputRef);
    },
    onPaste(event) {
      event.preventDefault();
      const paste = (event.clipboardData || window.clipboardData).getData("text");        
      this.search = paste;
    }
  },
  watch: {
    suggestions: function(val) {
      this.loadedSuggestions = val;
    },
    search : debounce(function(val) {
      if(!val || val === this.value) {
        return;
      }
      this.isLoading = true;
      this.loader(val).then((res) => {
        this.loadedSuggestions =res;
      }).finally(() => (this.isLoading = false))
    }, 500)
  },
};
</script>
